import {
  IonIcon,
  IonLabel,
  IonPage,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs,
  setupIonicReact
} from '@ionic/react'
import { appsSharp, bagHandleSharp, personCircleSharp } from 'ionicons/icons'
import { Redirect, Route } from 'react-router-dom'

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css'

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css'
import '@ionic/react/css/structure.css'
import '@ionic/react/css/typography.css'

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/display.css'
import '@ionic/react/css/flex-utils.css'
import '@ionic/react/css/float-elements.css'
import '@ionic/react/css/padding.css'
import '@ionic/react/css/text-alignment.css'
import '@ionic/react/css/text-transformation.css'

/* Styles sheets */
import './styles/styles.scss'

/* Import Pages */
import OBDValidationError from './components/error_screens/OBDValidationError'
import SaveProcedureError from './components/error_screens/SaveProcedureError'
import ActiveLinesError from './components/error_screens/ActiveLinesError'
import CheckOBDResponse from './components/obd/CheckOBDResponse'
import ActivacionPrepaga from './pages/ActivacionPrepaga/ActivacionPrepaga'
import ActivationDetails from './pages/ActivacionPrepaga/ActivationDetails'
import NuevaActivacionPrepaga from './pages/ActivacionPrepaga/NuevaActivacionPrepaga/NuevaActivacionPrepaga'
import ForeignNominativity from './pages/ForeignNominativity/ForeignNominativity'
import NewNominativity from './pages/ForeignNominativity/NewNominativity/NewNominativity'
import NominativityDetails from './pages/ForeignNominativity/NominativityDetails'
import InvalidSession from './pages/InvalidSession/InvalidSession'
import LoginPY from './pages/Login/LoginPY'
import MiCuenta from './pages/MiCuenta/MiCuenta'
import NuevaPortabilidadPY from './pages/Portabilidad/NuevaPortabilidad/NuevaPortabilidadPY'
import Portabilidades from './pages/Portabilidad/Portabilidades'
import PortabilityDetails from './pages/Portabilidad/PortabilityDetails'
import NuevoProspecto from './pages/Prospecto/NuevoProspecto'
import Prospectos from './pages/Prospecto/Prospectos'
import ReferredDetail from './pages/Prospecto/ReferredDetail'
import Tramites from './pages/Tramites/Tramites'

/* Context */
import { COUNTRY } from './const/constants'
import { useAppContext } from './context/AppContext'
import { StepsContextProvider } from './context/StepsContext'

/* Utils */
setupIonicReact()

const App = () => {
  const redirectClaroComercios = () => {
    location.href = settings.defaultValues.claroComerciosUrl
  }

  const { settings, user, blockNavigation, loginScreen }: any = useAppContext()

  const onInitRender = (component: any) =>
    Object.keys(settings).length && Object.keys(user).length ? component : <Redirect to="/procedures" />
  const onLogoutPY = () => (settings.country === COUNTRY.PY ? <Redirect to="/loginPY" /> : <></>)

  return (
    <StepsContextProvider>
      <IonPage>
        <IonTabs>
          <IonRouterOutlet>
            <Route exact path="/procedures" component={Tramites} />
            <Route exact path="/procedures/activaciones/check" component={CheckOBDResponse} />
            <Route exact path="/procedures/portabilidades/check" component={CheckOBDResponse} />
            <Route exact path="/account" render={() => onInitRender(<MiCuenta />)} />
            <Route exact path="/procedures/referidos" render={() => onInitRender(<Prospectos />)} />
            <Route exact path="/procedures/referidos/detalle" render={() => onInitRender(<ReferredDetail />)} />
            <Route exact path="/procedures/referidos/nuevo-referido" component={NuevoProspecto} />
            <Route exact path="/procedures/portabilidades" render={() => onInitRender(<Portabilidades />)} />
            <Route
              exact
              path="/procedures/portabilidades/nueva-portabilidad-py"
              render={() => onInitRender(<NuevaPortabilidadPY />)}
            />
            <Route
              exact
              path="/procedures/portabilidades/detalle"
              render={() => onInitRender(<PortabilityDetails />)}
            />
            <Route exact path="/procedures/activaciones" render={() => onInitRender(<ActivacionPrepaga />)} />
            <Route
              exact
              path="/procedures/activaciones/nueva-activacion"
              render={() => onInitRender(<NuevaActivacionPrepaga />)}
            />
            <Route exact path="/procedures/activaciones/detalle" render={() => onInitRender(<ActivationDetails />)} />
            <Route exact path="/procedures/validationError/activaciones" component={OBDValidationError} />
            <Route exact path="/procedures/validationError/portabilidades" component={OBDValidationError} />
            <Route exact path="/procedures/activaciones/error" component={SaveProcedureError} />
            <Route exact path="/procedures/portabilidades/error" component={SaveProcedureError} />
            <Route exact path="/procedures/preactivaciones/error-lineas-activas" component={ActiveLinesError} />
            <Route exact path="/procedures/nominatividad" render={() => onInitRender(<ForeignNominativity />)} />
            <Route
              exact
              path="/procedures/nominatividad/nueva-nominatividad"
              render={() => onInitRender(<NewNominativity />)}
            />
            <Route
              exact
              path="/procedures/nominatividad/detalle"
              render={() => onInitRender(<NominativityDetails />)}
            />
            <Route exact path="/invalid-session" component={InvalidSession} />
            <Route exact path="/loginPY" render={() => <LoginPY />} />
            <Route exact path="/logout" render={() => onLogoutPY()} />
            <Redirect to="/procedures" />
          </IonRouterOutlet>
          <IonTabBar id="bottom-bar" hidden={loginScreen} slot="bottom">
            <IonTabButton tab="procedures" href="/procedures" disabled={blockNavigation}>
              <IonIcon icon={appsSharp} />
              <IonLabel>Trámites</IonLabel>
            </IonTabButton>

            <IonTabButton tab="claro-comercios" onClick={redirectClaroComercios} disabled={blockNavigation}>
              <IonIcon icon={bagHandleSharp} />
              <IonLabel>{settings?.defaultValues?.comerciosLabel}</IonLabel>
            </IonTabButton>

            <IonTabButton tab="account" href="/account" disabled={blockNavigation}>
              <IonIcon icon={personCircleSharp} />
              <IonLabel>Mi cuenta</IonLabel>
            </IonTabButton>
          </IonTabBar>
        </IonTabs>
      </IonPage>
    </StepsContextProvider>
  )
}

export default App
